








import UiFiltersAndActions from '@/components/Ui/FiltersAndActions/FiltersAndActions.vue'
import SelectField, {SelectFieldOptions} from '@/components/Ui/ActiveForm/BZCore/Fields/SelectField'
import Vue from 'vue'
import wikiTree from '@/components/wiki/tree.vue'
export default Vue.extend({
  components: {
    UiFiltersAndActions,
    wikiTree
  },
  data () {
    return {
      tree: []
    }
  },
  methods: {
    search () {},
  }
})
